import React from 'react';

import LinearProgress from '@material-ui/core/LinearProgress';
import { withStyles } from '@material-ui/core/styles';

const CustomLinearProgress = withStyles(() => ({
  colorPrimary: {
    backgroundColor: 'transparent',
  },
  bar: {
    backgroundColor: 'var(--color-main-orange)',
  },
}))(LinearProgress);

export default function LinearLoading() {
  return <CustomLinearProgress />;
}
